import Vue from 'vue'

import VueRouter from 'vue-router'

import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import VueMaterial from 'vue-material'

import VueDebounce from 'vue-debounce'

import 'material-design-icons/iconfont/material-icons.css'

import App from './App.vue'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(VueMaterial)
Vue.use(VueDebounce)

const routes = [
  { path: '/*', component: App },
];

const router = new VueRouter({
  routes
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
